module.exports = __webpack_public_path__ + "media/countdown/primeday-d7235a31.jpg";